import { render, staticRenderFns } from "./rlzy.vue?vue&type=template&id=222f8248&scoped=true&"
import script from "./rlzy.vue?vue&type=script&lang=js&"
export * from "./rlzy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222f8248",
  null
  
)

export default component.exports